// js/script.js - Global Interactions for StickyCo

document.addEventListener('DOMContentLoaded', () => {
    
    // 1. Sticky Header on Scroll
    const header = document.getElementById('site-header');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        });
    }

    // 2. Mobile Nav Toggle
    const mobileMenuBtn = document.getElementById('mobile-menu-btn');
    const mobileNav = document.getElementById('mobile-nav');
    if (mobileMenuBtn && mobileNav) {
        mobileMenuBtn.addEventListener('click', () => {
            mobileNav.classList.toggle('hidden');
        });
    }

    // 3. Scroll-triggered animations
    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target); // Animate only once
            }
        });
    }, { threshold: 0.1 });

    animatedElements.forEach(el => observer.observe(el));

    // 4. Cookie Consent Banner
    const cookieBanner = document.getElementById('cookie-banner');
    const acceptCookiesBtn = document.getElementById('accept-cookies');
    const declineCookiesBtn = document.getElementById('decline-cookies');

    if (cookieBanner && !localStorage.getItem('cookieConsent')) {
        cookieBanner.classList.remove('hidden');
        
        acceptCookiesBtn?.addEventListener('click', () => {
            localStorage.setItem('cookieConsent', 'accepted');
            cookieBanner.classList.add('hidden');
        });

        declineCookiesBtn?.addEventListener('click', () => {
            localStorage.setItem('cookieConsent', 'declined');
            cookieBanner.classList.add('hidden');
        });
    } else if (cookieBanner) {
        cookieBanner.classList.add('hidden');
    }

    
    const collectionHandles = {
        'anime': 'anime-collection',
        'marvel': 'superhero-collection',
        'laptop': 'laptop-stickers',
        'gaming': 'gaming-stickers',
        'bike': 'bike-brand-logos',
        'names': 'name-labels',
        'corporate': 'business-branding'
    };

    window.applyServerSideCollection = async function(category) {
        const grid = document.getElementById('product-grid');
        if (!grid) return;
        
        let url = '/collections/all';
        if (category && category !== 'all') {
            const handle = collectionHandles[category] || category;
            url = '/collections/' + handle;
        }
        
        grid.innerHTML = '<div class="col-span-full text-center py-20"><p class="text-slate font-medium">Loading...</p></div>';
        
        try {
            const res = await fetch(url + '?section_id=collection-template');
            if (res.ok) {
                const text = await res.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');
                const newGrid = doc.getElementById('product-grid');
                if (newGrid) {
                    grid.innerHTML = newGrid.innerHTML;
                    
                    const newCount = doc.getElementById('shop-product-count');
                    const oldCount = document.getElementById('shop-product-count');
                    if (newCount && oldCount) oldCount.innerHTML = newCount.innerHTML;
                    return;
                }
            }
        } catch (e) {
            console.error(e);
        }
        
        grid.innerHTML = '<div class="col-span-full text-center py-20 text-red-500">Error loading products.</div>';
    };

    // Dropdown toggle logic
    const dropdownBtn = document.getElementById('filter-dropdown-btn');
    const dropdownMenu = document.getElementById('filter-dropdown-menu');
    const dropdownChevron = document.getElementById('dropdown-chevron');
    if (dropdownBtn && dropdownMenu) {
        dropdownBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            dropdownMenu.classList.toggle('hidden');
            if (dropdownChevron) dropdownChevron.style.transform = dropdownMenu.classList.contains('hidden') ? '' : 'rotate(180deg)';
        });
        document.addEventListener('click', (e) => {
            if (!dropdownBtn.contains(e.target) && !dropdownMenu.contains(e.target)) {
                dropdownMenu.classList.add('hidden');
                if (dropdownChevron) dropdownChevron.style.transform = '';
            }
        });
        
        // Prevent closing when clicking inside menu
        dropdownMenu.addEventListener('click', (e) => {
            e.stopPropagation();
        });
        
        // Apply Filters logic
        const applyBtn = document.getElementById('apply-filters-btn');
        const clearBtn = document.getElementById('clear-filters-btn');
        const checkboxes = document.querySelectorAll('.category-checkbox');
        
        if (applyBtn) {
            applyBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopPropagation();
                dropdownMenu.classList.add('hidden');
                if (dropdownChevron) dropdownChevron.style.transform = '';
                const selected = Array.from(checkboxes).filter(cb => cb.checked).map(cb => cb.value);
                await applyMultipleCollections(selected);
                
                // Update URL
                const newUrl = new URL(window.location);
                if (selected.length > 0) {
                    newUrl.searchParams.set('category', selected.join(','));
                } else {
                    newUrl.searchParams.delete('category');
                }
                window.history.pushState({}, '', newUrl);
            });
        }
        
        // Clear Filters logic
        if (clearBtn) {
            clearBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopPropagation();
                checkboxes.forEach(cb => cb.checked = false);
                dropdownMenu.classList.add('hidden');
                if (dropdownChevron) dropdownChevron.style.transform = '';
                dropdownBtn.querySelector('span').textContent = 'Filter by Category';
                await applyMultipleCollections([]);
                const newUrl = new URL(window.location);
                newUrl.searchParams.delete('category');
                window.history.pushState({}, '', newUrl);
            });
        }
        
        // Load initial from URL
        const urlParams = new URLSearchParams(window.location.search);
        const urlCategory = urlParams.get('category');
        if (urlCategory) {
            const cats = urlCategory.split(',');
            checkboxes.forEach(cb => {
                if (cats.includes(cb.value)) cb.checked = true;
            });
            applyMultipleCollections(cats);
        }
    }

    async function applyMultipleCollections(selectedCategories) {
        const grid = document.getElementById('product-grid');
        if (!grid || !dropdownBtn) return;
        
        if (selectedCategories.length === 0) {
            await window.applyServerSideCollection('all');
            dropdownBtn.querySelector('span').textContent = 'Filter by Category';
            return;
        }
        
        if (selectedCategories.length === 1) {
            await window.applyServerSideCollection(selectedCategories[0]);
            const cb = document.querySelector(`.category-checkbox[value="${selectedCategories[0]}"]`);
            if(cb) dropdownBtn.querySelector('span').textContent = cb.nextElementSibling.textContent;
            return;
        }
        
        dropdownBtn.querySelector('span').textContent = `${selectedCategories.length} Categories`;
        grid.innerHTML = '<div class="col-span-full text-center py-20"><p class="text-slate font-medium">Loading filters...</p></div>';
        
        let allProductCards = new Map();
        
        try {
            for (const cat of selectedCategories) {
                const handle = collectionHandles[cat];
                if (!handle) continue;
                
                const res = await fetch('/collections/' + handle + '?section_id=collection-template');
                if (res.ok) {
                    const text = await res.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(text, 'text/html');
                    const cards = doc.querySelectorAll('#product-grid > .product-card');
                    cards.forEach(card => {
                        const input = card.querySelector('input[name="id"]');
                        if (input) {
                            allProductCards.set(input.value, card.outerHTML);
                        }
                    });
                }
            }
            
            if (allProductCards.size === 0) {
                grid.innerHTML = '<div class="col-span-full text-center py-20"><i class="ph ph-ghost text-6xl text-slate mb-4 inline-block"></i><h3 class="text-2xl font-bold mb-2">No stickers found</h3><p class="text-slate font-medium">Try adjusting your filters or search terms.</p></div>';
                const count = document.getElementById('shop-product-count');
                if (count) count.textContent = '0 products';
                return;
            }
            
            grid.innerHTML = Array.from(allProductCards.values()).join('');
            
            const count = document.getElementById('shop-product-count');
            if (count) count.textContent = `${allProductCards.size} products`;
            
        } catch(e) {
            grid.innerHTML = '<div class="col-span-full text-center py-20 text-red-500">Error loading collections.</div>';
            console.error(e);
        }
    }

    
    
    // 6. Shop Page Search Logic (Shopify Section Rendering API)
    const shopSearchInput = document.getElementById('shop-search');
    if (shopSearchInput) {
        let debounceTimer;
        shopSearchInput.addEventListener('input', (e) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(async () => {
                const query = e.target.value.trim();
                const grid = document.getElementById('product-grid');
                if (!grid) return;
                
                // If empty, revert back to the selected categories
                if (!query) {
                    const checkboxes = document.querySelectorAll('.category-checkbox');
                    const selected = Array.from(checkboxes).filter(cb => cb.checked).map(cb => cb.value);
                    if (selected.length > 0) {
                        applyMultipleCollections(selected);
                    } else {
                        window.applyServerSideCollection('all');
                    }
                    return;
                }

                // Show loading state
                grid.innerHTML = '<div class="col-span-full text-center py-20"><div class="inline-block"><i class="ph ph-magnifying-glass text-4xl text-teal mb-4 animate-pulse inline-block"></i></div><p class="text-slate font-medium">Searching for "' + query + '"...</p></div>';

                try {
                    const response = await fetch('/search?q=' + encodeURIComponent(query) + '&type=product&section_id=search-template');
                    if (!response.ok) throw new Error('Search failed');
                    
                    const html = await response.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    
                    const newGrid = doc.getElementById('search-results-grid');
                    if (newGrid) {
                        grid.innerHTML = newGrid.innerHTML;
                        const count = document.getElementById('shop-product-count');
                        if (count) {
                            const cards = newGrid.querySelectorAll('.product-card');
                            count.textContent = cards.length > 0 ? cards.length + ' results' : '0 results';
                        }
                    } else {
                        grid.innerHTML = '<div class="col-span-full text-center py-20"><i class="ph ph-ghost text-6xl text-slate mb-4 inline-block"></i><h3 class="text-2xl font-bold mb-2">No results found</h3></div>';
                    }
                } catch (e) {
                    grid.innerHTML = '<div class="col-span-full text-center py-20 text-red-500">Error loading search results.</div>';
                    console.error(e);
                }
            }, 400); // 400ms debounce
        });
    }

    // 7. Add to Cart Button Animation (Removed for Shopify components)


    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(item => {
        const button = item.querySelector('.faq-button');
        const content = item.querySelector('.faq-content');
        const icon = item.querySelector('.faq-icon');

        if (button && content && icon) {
            button.addEventListener('click', () => {
                const isOpen = !content.classList.contains('hidden');
                
                // Close all others
                faqItems.forEach(otherItem => {
                    otherItem.querySelector('.faq-content')?.classList.add('hidden');
                    otherItem.querySelector('.faq-icon')?.classList.remove('rotate-180');
                });

                if (!isOpen) {
                    content.classList.remove('hidden');
                    icon.classList.add('rotate-180');
                }
            });
        }
    });

    // 9. Newsletter Validation (Simple)
    const newsletterForm = document.getElementById('newsletter-form');
    if (newsletterForm) {
        newsletterForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const input = newsletterForm.querySelector('input[type="email"]');
            if (input.value) {
                alert('Thanks for subscribing!');
                input.value = '';
            }
        });
    }
});
